import { Modal } from 'bootstrap';
import { EventService } from './event-service.js';

export default class ReCaptchaService extends EventService {

	constructor() {
		super();

		this.retryAction = null;
		this.retryCallback = null;
		this.dialog = document.getElementById('recaptcha-checkbox-dialog');
		this.siteKey = config.recaptcha_site_key;
		this.checkboxKey = config.recaptcha_checkbox_key;
	}

	init() {
		this.#loadEnterpriseScript();
	}

	#loadEnterpriseScript() {
		if (!this.siteKey || !this.checkboxKey) {
			return;
		}

		let script = document.querySelector('script[src*="https://www.google.com/recaptcha/enterprise.js"]');

		if (script) {
			return true;
		}

		// Print script
		script = document.createElement('script');
		script.src = `https://www.google.com/recaptcha/enterprise.js?render=${this.siteKey}&checkbox=${this.checkboxKey}`;
		script.onload = () => {
			this.trigger('grecaptcha_loaded');
		};

		document.head.appendChild(script);

		// hide reCAPTCHA badge with inline css + checkbox style
		let css = document.createElement('style');
			css.innerHTML =
				'.grecaptcha-badge { display: none !important }' +
				'#recaptcha-checkbox-dialog .modal-dialog { width: 329px }' +
				'#recaptcha-checkbox-dialog .modal-content { background: #f9f9f9 }' +
				'#recaptcha-checkbox-dialog .modal-body { padding: 15px 0 5px 15px }' +
				'#recaptcha-checkbox-dialog .recaptcha-widget > div > div { position: relative; overflow: hidden }' +
				'#recaptcha-checkbox-dialog .recaptcha-widget iframe { float: left; margin: -3px }' +
				'#recaptcha-checkbox-dialog .recaptcha-widget > div > div:after { content: ""; position: absolute; right: 0; top: 0; width: 10px; height: 100%; background: #f9f9f9 }';

		document.head.appendChild(css);
	}

	#loadCheckboxScript() {
		// remove old google script (change api JS to explicit)
		//	- switch site key script to checkbox key script
		// let script = document.querySelector('script[src*="recaptcha/enterprise.js?checkbox"]');
		let script = document.querySelector('script[src*="recaptcha/enterprise.js"]');

		if (!script) {
			script = document.querySelector('script[src*="recaptcha/enterprise.js?onload=init&checkbox"]');
		}

		if (script) {
			let newScript = document.createElement('script');
			newScript.src = script.src.split('?')[0] + '?onload=renderReCaptchaCheckbox&render=explicit';
			newScript.onload = () => {
				this.trigger('grecaptcha_checkbox_loaded');
			};

			script.remove();
			document.querySelector('head').appendChild(newScript);
		}
	}

	requestToken(action) {
		const self = this;

		if (!this.siteKey || !this.checkboxKey) {
			console.log('2. requestToken with fake response', action, this.siteKey);

			return self.trigger('executed_' + action, {recaptcha_token: 'inactivated_recaptcha_token', action: action})
		}

		console.log('2. requestToken', action, this.siteKey);

		return grecaptcha.enterprise.execute(this.siteKey, { action: action })
			.then((token) => self.trigger('executed_' + action, {recaptcha_token: token, action: action}));
	}

	doCheckbox() {
		console.log('4. Do checkbox');
		const self = this;

		self.dialog = document.getElementById('recaptcha-checkbox-dialog');

		// add modal to DOM if not exists
		if (!self.dialog) {
			const dialogWrapper = document.createElement('div');
			dialogWrapper.innerHTML = `<div class="modal" id="recaptcha-checkbox-dialog" role="dialog" tabindex="-2" aria-labelledby="message-modal-title" aria-hidden="true">
				<div class="modal-dialog" role="document">
					<div class="modal-content">
						<div class="modal-body">
							<div id="recaptcha-checkbox" class="recaptcha-widget"></div>
						</div>
					</div>
				</div>
			</div>`;
			self.dialog = dialogWrapper.firstChild;
			document.body.appendChild(self.dialog);
		}

		// show modal
		self.dialog.classList.remove('callbacked');
		const modalInstance = Modal.getOrCreateInstance(self.dialog);
		modalInstance.show();

		this.#loadCheckboxScript();

		window.runWithCaptchaCallback = this.runWithCaptchaCallback;

		// reCAPTCHA onload callback
		//	- for Google, otherwise it wont work
		window.renderReCaptchaCheckbox = () => {
			console.log('5. Render checkbox', self.checkboxKey);
			// render widget
			grecaptcha.enterprise.render('recaptcha-checkbox', {
				sitekey: self.checkboxKey,
				callback: runWithCaptchaCallback
			});
		};
	}

	runWithCaptchaCallback(token) {
		const self = window.reCaptchaService;
		console.log('6. runWithCaptchaCallback', self.retryCallback);

		self.retryCallback(token, true);

		if (self.dialog) {
			self.dialog.classList.add('callbacked');
			const modalInstance = Modal.getInstance(self.dialog);
			if (modalInstance) {
				modalInstance.hide();
			}
		}
	}

	runWithCheckbox(action, callback) {
		this.retryAction = action;
		this.retryCallback = callback;

		this.doCheckbox();
	}

	runWithCaptcha(action, callback) {
		console.log('1. runWithCaptcha', action);

		this.retryAction = action;
		this.retryCallback = callback;

		this.once('executed_' + this.retryAction, (event) => {
			if (event.recaptcha_token && this.retryAction === event.action) {
				console.log('3. retryCallback', this.retryAction, event);
				this.retryCallback(event.recaptcha_token);
			} else {
				console.error('3. ReCaptcha executed without token received');

				this.resetOnce('executed_' + this.retryAction);
			}
		});

		this.requestToken(action);
	}
}